(ns manage.adset-decision-tree-page.tagging-and-trackers.tracker.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.widgets.form-field :refer [form-field]]
            [manage.adset-decision-tree-page.tagging-and-trackers.macro-input :refer [macro-input]]
            [manage.adset-decision-tree-page.tagging-and-trackers.tracker.db :as tracker]
            [manage.adset-decision-tree-page.view.common :refer [landing-url-info-tooltip]]
            [manage.adset.hooks :as adset.h]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui tracker-list-item-fields [{:keys [index tracker-type value-text]}]
  (let [adset-channel (adset.h/use-channel)]
    ($ Stack {:direction "row" :gap 2}
       ($ form-field
          {:sx #js {:flexBasis "34%"}
           :label "Tracker type"
           :data-testid "tracker-param-type-select"}
          ($ Select {:sx #js {:width "100%"}
                     :size "small"
                     :disabled (= adset-channel "meta")
                     :value (or tracker-type "")
                     :onChange (fn [^js event]
                                 (let [value (-> event .-target .-value)]
                                   (rf/dispatch [::tracker/set-tracker-type index value])))}
             ($ MenuItem {:value "click"} "Click")
             (when-not (= adset-channel "meta")
               ($ MenuItem {:value "impression"} "Impression"))))
       ($ form-field {:sx #js {:flexBasis "66%"}
                      :label "Value"
                      :data-testid "tracker-param-value-input"
                      :label-action (when (= tracker-type "click")
                                      ($ landing-url-info-tooltip))}
          ($ macro-input {:value (or value-text "")
                          :allow-macros? true
                          :on-change (fn [value]
                                       (rf/dispatch [::tracker/set-tracker-value index value]))}))
       ($ IconButton
          {:sx #js {:alignSelf "flex-end"}
           :onClick (fn [^js _event]
                      (rf/dispatch [::tracker/delete-tracker-param index]))
           :data-testid "delete-tracker-param"}
          ($ Icon "delete")))))

(defui tracker-list-item-message [{:keys [index]}]
  (let [only-1-click-tracker-error (use-subscribe [::tracker/only-1-click-tracker-error index])
        invalid-tracker-url-error-message (use-subscribe [::tracker/invalid-tracker-url-error-message index])
        {:keys [message color] :as warning-map}
        (cond
          only-1-click-tracker-error {:message "It's not possible to add multiple Click Trackers to the same adset."
                                      :color "error.main"}
          invalid-tracker-url-error-message {:message "The placeholder expression should be a URL."
                                             :color "error.main"})]
    (when warning-map
      ($ Stack {:direction "row"
                :alignItems "center"
                :spacing 1
                :sx #js {:my 1
                         :color color}}
         ($ Icon "warning")
         ($ Typography message)))))

(defui tracker-list-item [{:keys [index tracker-type value-text]}]
  ($ :<>
     ($ tracker-list-item-fields {:index index :tracker-type tracker-type :value-text value-text})
     ($ tracker-list-item-message {:index index})))

(defui tab-panel []
  ($ Stack {:spacing 2}
     (for [[index {:keys [type value]}] (mc/seq-indexed (use-subscribe [::tracker/tracker-params]))]
       ($ tracker-list-item {:key index :index index :tracker-type type :value-text value}))
     ($ Button {:startIcon ($ Icon "add")
                :variant "text"
                :onClick (fn [^js _event]
                           (rf/dispatch [::tracker/add-tracker-param]))
                :sx #js {:alignSelf "start"}}
        "Add new tracker")))
